import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import { SidebarDistributionLineLocationMasterPostDataAPI } from '../../../../../../Redux/SidebarMasterSlice/WaterSupplySidebarSlice/WaterSupplyDistributionLineLocationMasterSlice';
import { useAuthState } from '../../../../../../Helper/Context';
import { useDispatch, useSelector } from 'react-redux';
import { WardNameDataDDL } from '../../../../../../Components/CommonDDL/WardNameDataDDL';
import { AstricSign } from '../../../../../../Helper/AstricSign';


export default function WaterSupplyLocationMasterPopup(props) {
    const { handleOnCloseClick, open, Flag, apiFlag, rowData, handleIsPost,DashProjectTypeId } = props

    const userDetails = useAuthState();
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch();

    const [WardName, setWardName] = useState({
        DDL: [],
        ID: Flag === 'Update' ? rowData.m_WardID : 0,
        Label: Flag === 'Update' ? rowData.wardName : "Select...",
    })

    const [LocationName, setLocationName] = useState(Flag === 'Update' ? rowData.locationDetails : '')
    const [IsClear, setIsClear] = useState(false)

    const [IsOpen, setIsOpen] = useState(false)


    const handleClear = () => {
        setIsClear(!IsClear)
        setLocationName('')
        setWardName({
            ...WardName,
            ID: 0,
            Label: 'Select...',
        })
    }

    const handlePost = () => {
        const data = {
            M_Distri_WS_LocationID: Flag === 'Update' ? rowData.m_Distri_WS_LocationID : '0',
            M_WS_LocationID:Flag === 'Update' ? rowData.m_wS_LocationID : '0',
            M_WardID: WardName.ID,
            LocationDetails: LocationName,
            M_UserID: UserID,
            token: token,
            Flag: Flag === 'Update' ? 'Update' : 'Insert',
            handleIsPost: handleIsPost,
            handleOnCloseClick: handleOnCloseClick,
            DashProjectTypeId:DashProjectTypeId,

        }
        dispatch(SidebarDistributionLineLocationMasterPostDataAPI({ data }))
    }
    const { isPostLoading } = useSelector(state => state.SidebarDistributionLineLocationMasterPostData)


    return (
        <Popup
            open={open} closeOnDocumentClick={false} onClose={handleOnCloseClick}
        >
            <div className="modal-dialog water_pop modal-xl">
                <div className="modal-content">
                    <div className="modal-header pl-4 p-1">
                        <h4 className="modal-title" id="staticBackdropLabel">Location Master</h4>
                        <button onClick={handleOnCloseClick} className="btn-close m-1 mr-3" type="button" />
                    </div>

                    <div className="modal-body">
                        <div className='inner-modal-body'>

                            <div className="row details-row">

                                <div className="col-md-6 col-lg-6">
                                    <WardNameDataDDL
                                        WardName={WardName}
                                        setWardName={setWardName}
                                        rowData={rowData}
                                        Flag={Flag}
                                    />
                                </div>
                                <div className="col-md-6 col-lg-6">
                                    <div className="form-group">
                                        <label className="d-block" htmlFor="NameofDepartment"><b>Location <AstricSign /></b></label>
                                        <input type="text"
                                            className="form-control"
                                            id="LocationName"
                                            value={LocationName}
                                            onChange={(e) => setLocationName(e.target.value)}

                                        />
                                    </div>

                                </div>
                            </div>

                            <div className="col-12 col-lg-12 pt-lg-5">
                                <div className="btn-action d-flex justify-content-end ">
                                    <button type='button'
                                        className="btn allBtn  float-right submit_btn"
                                        onClick={() => (handlePost(), handleClear())}
                                        disabled={
                                            WardName.ID == 0 || LocationName == ''
                                        }
                                    >{Flag === "Update" ? "Update" : "Save"} </button>
                                    <button type="button" className="btn addBtns cancel_btn ms-2 mr-2 mx-2  float-right" onClick={handleOnCloseClick} >Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* )} */}
        </Popup>
    )

}